import { buildBaseSchema } from './schema'

/** Ready multi-doctor clinic (کلینیک) site schema. */
export const clinicTemplate = buildBaseSchema('clinic')
